import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { takeWhileAlive } from '@core/frontend-shared';
import { BehaviorSubject, combineLatest, map } from 'rxjs';
import { convertToBehaviorSubject } from '@core/shared/utils';
import * as i0 from "@angular/core";
export let AccessibilityThemeService = /*#__PURE__*/(() => {
  class AccessibilityThemeService {
    get currentTheme$() {
      return this._currentTheme$.asObservable();
    }
    get currentTheme() {
      return this._currentTheme$.getValue();
    }
    constructor() {
      this.isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
      this.browserTheme$ = new BehaviorSubject(null);
      this.nightTime$ = new BehaviorSubject(null);
      this.config$ = new BehaviorSubject({
        enabled: true,
        config: {
          mode: 'inherit-browser'
        }
      });
      this.state$ = combineLatest({
        browserTheme: this.browserTheme$,
        nightTime: this.nightTime$,
        config: this.config$
      }).pipe(takeWhileAlive(), map(({
        browserTheme,
        nightTime,
        config
      }) => {
        return {
          browserTheme,
          nightTime,
          ...config
        };
      }));
      this._currentTheme$ = convertToBehaviorSubject('dark')(this.state$.pipe(map(({
        browserTheme,
        nightTime,
        enabled,
        config
      }) => {
        let themeValue;
        // @ts-ignore
        if (config.mode === 'dark' || config.mode === 'light') {
          themeValue = config.mode;
        } else if (config.mode === 'always') {
          themeValue = 'dark';
        } else if (config.mode === 'never') {
          themeValue = 'light';
        } else if (config.mode === 'contrast') {
          themeValue = 'contrast';
        } else if (config.mode === 'inherit-browser') {
          themeValue = browserTheme;
        } else if (config.mode === 'night-time') {
          themeValue = nightTime ? 'dark' : 'light';
        }
        return themeValue;
      })));
      this.prefersColorThemeChangeHandler = arg => {
        const matches = typeof arg === 'boolean' ? arg : arg.matches;
        this.browserTheme$.next(matches ? 'dark' : 'light');
      };
      this.isNightTimeHandler = () => {
        const hours = new Date().getHours();
        const isNightTime = hours > 21 || hours < 7;
        this.nightTime$.next(isNightTime);
      };
      if (this.isBrowser) {
        if (window?.matchMedia) {
          this.preferDarkTheme = window.matchMedia("(prefers-color-scheme: dark)");
          this.preferDarkTheme.addEventListener("change", this.prefersColorThemeChangeHandler);
          this.prefersColorThemeChangeHandler(this.preferDarkTheme.matches);
        }
        this.intervalSubscr = setInterval(this.isNightTimeHandler, 10 * 60 * 1000);
      }
    }
    updateConfig(config) {
      this.config$.next(config);
    }
    ngOnDestroy() {
      clearInterval(this.intervalSubscr);
      if (this.preferDarkTheme) this.preferDarkTheme.removeEventListener("change", this.prefersColorThemeChangeHandler);
    }
    static {
      this.ɵfac = function AccessibilityThemeService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AccessibilityThemeService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: AccessibilityThemeService,
        factory: AccessibilityThemeService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AccessibilityThemeService;
})();